(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.stickyType = this.getAttribute('data-sticky-type');
    }

    connectedCallback() {
      this.init();
    }

    init() {
      if (typeof gsap === 'undefined') {
        setTimeout(() => this.init(), 100);
        return;
      }

      this.setHeaderHeight();
      
      if (this.stickyType === 'none') return;

      let lastScrollY = window.scrollY || document.documentElement.scrollTop;
      let isHidden = false;
      let accum = 0;
      
      const loop = () => {
         let currentScrollY = window.scrollY || document.documentElement.scrollTop;
         if (window.lenis && typeof window.lenis.scroll === 'number') {
            currentScrollY = window.lenis.scroll;
         }
         
         // Only recalculate header height periodically or right at start to avoid layout thrashing
         if (accum === 0 || currentScrollY < 100 || !this._lastHeight) {
            this.setHeaderHeight();
         }

         if (currentScrollY !== lastScrollY) {
            const diff = currentScrollY - lastScrollY;
            lastScrollY = currentScrollY;
            
            // Detection for Product Page Transparency
            if (window.location.pathname.includes('/products/')) {
               document.documentElement.setAttribute('data-on-product', 'true');
            }

            const isTransparent = this.getAttribute('data-is-transparent') === 'true';
            const threshold = isTransparent ? 150 : 5;

            // 1. Initial State
            if (currentScrollY <= threshold) {
              this.classList.remove('is-sticky');
              document.documentElement.removeAttribute('data-header-sticky');
              
              if (isHidden) {
                  gsap.to(this, { y: '0%', duration: 0.3, ease: 'power2.out', overwrite: true });
                  isHidden = false;
              }
              accum = 0;
            } else {
              // 2. Sticky State
              if (!this.classList.contains('is-sticky')) {
                  this.classList.add('is-sticky');
              }
              document.documentElement.setAttribute('data-header-sticky', 'true');
              
              const isMenuOpen =
                document.body.classList.contains('mega-menu-open') ||
                document.documentElement.classList.contains('mobile-menu-scroll-locked');
              
              if (isMenuOpen) {
                  if (isHidden) {
                      gsap.to(this, { y: '0%', duration: 0.3, ease: 'power2.out', overwrite: true });
                      isHidden = false;
                  }
              } else if (this.stickyType === 'on-scroll-up') {
                  if (diff > 0) { // scrolling down
                      accum = Math.max(0, accum + diff);
                      if (accum > 15 && !isHidden && currentScrollY > 300) {
                          gsap.to(this, { y: '-101%', duration: 0.4, ease: "power3.inOut", overwrite: true });
                          isHidden = true;
                      }
                  } else if (diff < 0) { // scrolling up
                      accum = Math.min(0, accum + diff);
                      if (accum < -15 && isHidden) {
                          gsap.to(this, { y: '0%', duration: 0.4, ease: "power3.out", overwrite: true });
                          isHidden = false;
                      }
                  }
              } else if (this.stickyType === 'always') {
                  if (isHidden) {
                      gsap.to(this, { y: '0%', duration: 0.3, ease: 'power2.out', overwrite: true });
                      isHidden = false;
                  }
              }
            }
         }
         
         this.rAF = requestAnimationFrame(loop);
      };
      
      this.rAF = requestAnimationFrame(loop);
    }

    disconnectedCallback() {
      if (this.rAF) cancelAnimationFrame(this.rAF);
    }

    setHeaderHeight() {
      const currentHeight = this.offsetHeight;
      if (this._lastHeight !== currentHeight) {
        document.documentElement.style.setProperty('--header-height', `${currentHeight}px`);
        this._lastHeight = currentHeight;
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // CodePen-Inspired Mega Menu Animation (Height Expand + Stagger)
  function initHeaderHover() {
    const container = document.getElementById('MegaMenuContainer');
    const overlay = document.getElementById('MegaMenuOverlay');
    const triggers = document.querySelectorAll('.header__inline-menu .header__menu-item');
    const panels = document.querySelectorAll('.mega-menu-panel');
    const body = document.body;
    let hoverTimeout;

    // Wait for GSAP
    if (typeof gsap === 'undefined') {
        setTimeout(initHeaderHover, 100);
        return;
    }

    // Helper: Roll Text Animation
    const rollText = (trigger, direction) => {
        const primary = trigger.querySelector('.hover-text-primary');
        const secondary = trigger.querySelector('.hover-text-secondary');
        if (!primary || !secondary) return;

        if (direction === 'in') {
            gsap.to(primary, { y: '-100%', duration: 0.4, ease: "power2.out" });
            gsap.to(secondary, { y: '-100%', duration: 0.4, ease: "power2.out" });
        } else {
            gsap.to(primary, { y: '0%', duration: 0.4, ease: "power2.out" });
            gsap.to(secondary, { y: '0%', duration: 0.4, ease: "power2.out" });
        }
    };

    // Initialize CSS states for GSAP
    if (container) {
        gsap.set(container, { 
            height: 0, 
            display: 'block', 
            autoAlpha: 0, // Start fully invisible to prevent 1px lines
            overflow: 'hidden'
        });
    }

    const closeAll = (immediate = false) => {
      clearTimeout(hoverTimeout);
      
      const doClose = () => {
        if (!immediate && (body.matches(':hover') || container.matches(':hover'))) {
          // Check if hovering ANY trigger
          const isOverTrigger = Array.from(triggers).some(t => t.matches(':hover'));
          if (isOverTrigger || container.matches(':hover')) return;
        }

        // Close Animation: Reverse the open logic
        if (container && container.offsetHeight > 0) {
            // Animate Height to 0 and Fade Out
            gsap.to(container, {
                height: 0,
                autoAlpha: 0, // Fade out to ensure invisibility
                duration: 0.8,
                ease: "power4.inOut"
            });
            
            // Fade out content quickly
            const activePanel = container.querySelector('.mega-menu-panel[style*="display: block"]');
            if (activePanel) {
                const content = activePanel.querySelectorAll('.mega-menu__main-link, .mega-menu__extra-btn, .mega-menu__featured-side, .mega-menu__info-panel');
                gsap.to(content, { opacity: 0, duration: 0.3 });
            }
        }
        
        if (overlay) {
            gsap.to(overlay, { duration: 0.8, autoAlpha: 0, onComplete: () => overlay.classList.remove('is-active') });
        }

        body.classList.remove('mega-menu-open');
        triggers.forEach(t => {
            t.classList.remove('is-active');
            rollText(t, 'out'); 
        });
        
        // Cleanup after animation
        setTimeout(() => {
            if (container.offsetHeight === 0) {
                 panels.forEach(p => p.style.display = 'none');
                 container.classList.remove('is-active');
            }
        }, 800);
      };

      if (immediate) {
        doClose();
      } else {
        hoverTimeout = setTimeout(doClose, 100);
      }
    };

    const normalizeMenuPath = (value) => {
      if (!value || value.startsWith('#')) return null;

      try {
        const url = new URL(value, window.location.origin);
        let path = url.pathname.replace(/\/+$/, '') || '/';
        const localeRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        const localePath = new URL(localeRoot, window.location.origin).pathname.replace(/\/+$/, '');

        if (localePath && localePath !== '/' && (path === localePath || path.startsWith(`${localePath}/`))) {
          path = path.slice(localePath.length) || '/';
        }

        return path.toLowerCase();
      } catch (error) {
        return null;
      }
    };

    const getMenuPaths = (element) => new Set(
      (element.getAttribute('data-menu-links') || '')
        .split('|')
        .map(normalizeMenuPath)
        .filter(Boolean)
    );

    const normalizeMenuHandle = (value) => {
      const normalizedValue = (value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-');

      const aliases = {
        banheiras: new Set(['banheiras', 'banheiras-de-gelo', 'banho-de-gelo', 'banhos-de-gelo', 'ice-bath', 'ice-baths', 'bathtub', 'bathtubs', 'cold-plunge', 'cold-plunges', 'baneras', 'bano-de-hielo', 'banos-de-hielo', 'bain-de-glace', 'bains-de-glace', 'baignoire', 'baignoires']),
        saunas: new Set(['sauna', 'saunas']),
        mais: new Set(['mais', 'more', 'mas', 'plus', 'view-all', 'see-more', 'explore-more', 'ver-mais', 'ver-mas', 'ver-todo', 'ver-todos', 'voir-plus', 'voir-tout', 'tout-voir']),
        elite: new Set(['elite'])
      };

      return Object.keys(aliases).find(key => aliases[key].has(normalizedValue)) || normalizedValue;
    };

    const findTargetPanel = (handle, trigger) => {
      const normalizedHandle = normalizeMenuHandle(handle);
      const panelList = Array.from(panels);
      const handleMatch = panelList.find(panel => (
        normalizeMenuHandle(panel.getAttribute('data-menu-handle')) === normalizedHandle
      ));

      if (handleMatch) return handleMatch;

      const triggerPaths = getMenuPaths(trigger);
      let bestMatch = null;
      let bestScore = 0;

      panelList.forEach(panel => {
        const panelPaths = getMenuPaths(panel);
        const score = Array.from(triggerPaths).filter(path => panelPaths.has(path)).length;

        if (score > bestScore) {
          bestMatch = panel;
          bestScore = score;
        }
      });

      return bestMatch;
    };

    const openPanel = (handle, trigger) => {
      clearTimeout(hoverTimeout);
      const targetPanel = container ? findTargetPanel(handle, trigger) : null;
      
      // Reset other triggers
      triggers.forEach(t => {
          if (t !== trigger) {
              t.classList.remove('is-active');
              rollText(t, 'out');
          }
      });
      
      trigger.classList.add('is-active');
      rollText(trigger, 'in'); // Roll text in

      if (targetPanel) {
        // 1. Activate Logic
        panels.forEach(p => p.style.display = 'none');
        targetPanel.style.display = 'block';

        const isAlreadyOpen = container.offsetHeight > 5; // Tolerance
        container.classList.add('is-active');
        if (overlay) {
            overlay.classList.add('is-active');
            gsap.to(overlay, { duration: 0.5, autoAlpha: 1 });
        }
        body.classList.add('mega-menu-open');
        
        document.querySelectorAll('header-menu details[open]').forEach(details => {
             details.removeAttribute('open');
        });

        // 2. The Animation
        // Select Content
        const contentElements = targetPanel.querySelectorAll('.mega-menu__card');
        
        // Reset opacity/transform for incoming elements
        gsap.set(contentElements, { opacity: 0, y: 20 });

        if (!isAlreadyOpen) {
            // A) Closed -> Open
            gsap.fromTo(container, 
                { height: 0, autoAlpha: 0 },
                { 
                    duration: 0.8, 
                    height: "auto", 
                    autoAlpha: 1, 
                    ease: "power4.out",
                    overwrite: true
                }
            );

            // Animate Cards: Opacity 0 -> 1 with Stagger
            gsap.to(contentElements, {
                duration: 0.8,
                opacity: 1,
                y: 0,
                ease: "power3.out",
                stagger: 0.1,
                delay: 0.2
            });
            
        } else {
            // B) Open -> Open (Switching Tabs)
            gsap.to(container, {
                duration: 0.4,
                height: "auto",
                autoAlpha: 1,
                ease: "power4.out"
            });
             
            gsap.to(contentElements, {
                duration: 0.6,
                opacity: 1,
                y: 0,
                ease: "power2.out",
                stagger: 0.05
            });
        }

      } else {
        // Fallback or Standard Dropdown
        const details = trigger.closest('details');
        if (details) {
          details.setAttribute('open', '');
          if (container) closeAll(true);
        } else {
          closeAll();
        }
      }
    };

    triggers.forEach(trigger => {
      trigger.addEventListener('mouseenter', () => {
        const handle = trigger.getAttribute('data-handle');
        if (handle) openPanel(handle, trigger);
        else rollText(trigger, 'in'); // Just roll if no handle
      });

      trigger.addEventListener('mouseleave', () => {
        hoverTimeout = setTimeout(closeAll, 100);
      });
    });

    if (container) {
      container.addEventListener('mouseenter', () => clearTimeout(hoverTimeout));
      container.addEventListener('mouseleave', () => {
        hoverTimeout = setTimeout(closeAll, 100);
      });
    }
    
    // Standard submenus closing mega menu
    document.querySelectorAll('.header__submenu').forEach(submenu => {
      submenu.addEventListener('mouseenter', () => clearTimeout(hoverTimeout));
      submenu.addEventListener('mouseleave', () => {
        hoverTimeout = setTimeout(closeAll, 100);
      });
    });

    // Close on Scroll with Tolerance
    let lastScrollPos = window.scrollY;
    window.addEventListener('scroll', () => {
      const currentScrollPos = window.scrollY;
      // Only close if scroll difference is significant (> 10px) to prevent layout-shift triggers
      if (Math.abs(currentScrollPos - lastScrollPos) > 10) {
          if ((container && container.offsetHeight > 0) || body.classList.contains('mega-menu-open')) {
            closeAll(true); 
          }
      }
      lastScrollPos = currentScrollPos;
    }, { passive: true });
  }

  // Initialize on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderHover);
  } else {
    initHeaderHover();
  }

  // Initialize in Theme Editor
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('section-header')) {
      initHeaderHover();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
